import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <div className="contact-container">
            <div className="contact-header">
                <h1 style={{textAlign:"center"}}>Vamos manter-nos em contacto</h1>
                <p className="schedule-title">HORÁRIO DE ATENDIMENTO</p>
                <p>Segunda - Sexta</p>
                <p>08:00h - 17:00h</p>
            </div>

            <div className="contact-content">
                <div className="contact-section">
                    <h3>Localização</h3>
                    <p>
                    Centralidade do Kilamba <br />
                    Quarteirão F, edifício F27,apartamento 91 Kilamba <br />
                        Luanda - Angola
                    </p>

                    <h3>Telefone</h3>
                    <p>(+244) 921 909 103</p>
                    <p>(+244) 972 614 886</p>

                    <h3>Email</h3>
                    <p>geral@nwayami.com</p>

                    <h3>Whatsapp</h3>
                    <p>(+244) 972 614 886</p>
                </div>

                <div className="contact-section">
                    <h3>Contactos Comerciais</h3>
                    <p>(+244) (+244) 921 793 774</p>
                    <p><strong>Email:</strong> geral@nwayami.com</p>

                    <h3>Contactos Assistência Técnica</h3>
                    <p>(+244) 921 791 707 / 921 902 078</p>
                    <p><strong>Email:</strong> suporte@nwayami.com</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
